import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function DocumentsPagination({
  page,
  totalPages,
  total,
  limit,
  onPrev,
  onNext,
  disabled,
}) {
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  if (totalPages <= 1) {
    return (
      <div className="mt-6 rounded-3xl border border-slate-200 bg-white px-5 py-4 text-sm font-semibold text-slate-600 shadow-sm dark:border-slate-800 dark:bg-slate-950 dark:text-slate-300">
        {total} résultat{total > 1 ? "s" : ""}
      </div>
    );
  }

  return (
    <div className="mt-6 flex flex-col gap-3 rounded-3xl border border-slate-200 bg-white px-5 py-4 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:flex-row sm:items-center sm:justify-between">
      <div className="text-sm font-semibold text-slate-600 dark:text-slate-300">
        Résultats {start} à {end} sur {total}
      </div>

      <div className="flex items-center justify-between gap-3 sm:justify-end">
        <button
          type="button"
          onClick={onPrev}
          disabled={disabled || page <= 1}
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
          aria-label="Page précédente"
        >
          <FiChevronLeft className="h-5 w-5" />
        </button>

        <span className="min-w-20 text-center text-sm font-bold text-slate-700 dark:text-slate-200">
          {page} / {totalPages}
        </span>

        <button
          type="button"
          onClick={onNext}
          disabled={disabled || page >= totalPages}
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
          aria-label="Page suivante"
        >
          <FiChevronRight className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}